import createSpacing from '@material-ui/core/styles/createSpacing';

export const SCALING_FACTOR = 0.25;
export const factor = (factor: number | string) =>
  typeof factor === 'string' ? factor : `${SCALING_FACTOR * factor}rem`;
export const spacing = createSpacing(factor);
